import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { RoutingService, TranslatePipe } from '@spartacus/core';
import { Subscription } from 'rxjs';

import { KnBrProductSelectService } from '../../../services/kn-br-product-select.service';
import { KnBrProductSalesOrgService, SALESORG } from 'src/app/services/kn-br-product-sales-org.service';
import { DomSanitizer } from '@angular/platform-browser';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ProductListOutlets, MediaComponent, ItemCounterComponent } from '@spartacus/storefront';
import { formatTwoDecimals } from 'src/constants/commonUtils';
import { KnBrAddToCartComponent } from '../../kn-br-add-to-cart/kn-br-add-to-cart.component';

@Component({
    selector: 'kn-br-product-grid-item',
    templateUrl: './kn-br-product-grid-item.component.html',
    styleUrls: ['./kn-br-product-grid-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MediaComponent, ItemCounterComponent, KnBrAddToCartComponent, TranslatePipe]
})
export class KnBrProductGridItemComponent implements OnDestroy, OnChanges {
  @Input() product: any;
  @Input() editable: boolean;
  salesOrg: SALESORG = {};
  selectedProductsCodes: string[];
  subscription: Subscription;
  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  });
  readonly ProductListOutlets = ProductListOutlets;

  constructor(
    protected productSelectService: KnBrProductSelectService,
    protected routingService: RoutingService,
    protected knBrProductSalesOrgService: KnBrProductSalesOrgService,
    private _sanitizer: DomSanitizer,
    private knBrCommonService: KnBrCommonService
  ) {
    this.subscription = this.productSelectService.loadSelectedProducts$().subscribe((selectedProductsCodes) => {
      this.selectedProductsCodes = selectedProductsCodes;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getSalesOrg(this.product.salesOrg);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getSalesOrg(salesOrg: string) {
    const _salesOrg = this.knBrProductSalesOrgService.getSalesOrgDetails(salesOrg);
    if (_salesOrg) {
      this.salesOrg = _salesOrg;
    }
  }

  getSVGImage(image) {
    return image ? this._sanitizer.bypassSecurityTrustHtml(`${image}`) : '';
  }

  isChecked(code: string): boolean {
    if (this.selectedProductsCodes) {
      return this.selectedProductsCodes.indexOf(code) > -1;
    }
    return false;
  }
  changeCheckBox(event) {
    event.stopPropagation();
    const selectedProductCodes = event.currentTarget.checked ? this.addProductCode() : this.removeProductCode();
    this.productSelectService.setSelectedProducts(selectedProductCodes);
  }
  goToDetail(event) {
    // avoid PDP routing on add to cart seciton
    if (event.target.closest('.product-actions')) {
      return;
    }

    this.knBrCommonService.setSpinner(true);
    this.routingService.go({ cxRoute: 'product', params: this.product });
    
  }
  addProductCode() {
    if (this.selectedProductsCodes && this.selectedProductsCodes.length) {
      this.selectedProductsCodes.push(this.product.code);
    } else {
      this.selectedProductsCodes = [this.product.code];
    }
    return this.selectedProductsCodes;
  }
  removeProductCode() {
    this.selectedProductsCodes.splice(this.selectedProductsCodes.indexOf(this.product.code), 1);
    return this.selectedProductsCodes;
  }

  formatPrice(priceValue) {
    return formatTwoDecimals(priceValue)
  }
}
